export default "__VITE_ASSET__BTakW1WR__"